export default function run(amMoment) {
	amMoment.changeLocale('de');
}
